(() => {
  if (!window.matchMedia('(max-width: 749px)').matches) return;

  const phrases = ["don't miss out", "don’t miss out"];

  const hideInjectedFormsTab = () => {
    document.querySelectorAll('body *').forEach((element) => {
      if (!(element instanceof HTMLElement)) return;
      const text = (element.textContent || '').trim().toLowerCase();
      if (!phrases.some((phrase) => text === phrase || text.startsWith(phrase))) return;

      let node = element;
      for (let depth = 0; depth < 7 && node; depth += 1) {
        const style = window.getComputedStyle(node);
        const idClass = `${node.id || ''} ${node.className || ''}`.toLowerCase();
        if (
          style.position === 'fixed' ||
          idClass.includes('shopify-form') ||
          idClass.includes('forms-app') ||
          idClass.includes('teaser')
        ) {
          node.style.setProperty('display', 'none', 'important');
          node.setAttribute('aria-hidden', 'true');
          break;
        }
        node = node.parentElement;
      }
    });
  };

  hideInjectedFormsTab();
  const observer = new MutationObserver(hideInjectedFormsTab);
  observer.observe(document.documentElement, { childList: true, subtree: true });
  window.setTimeout(() => observer.disconnect(), 15000);
})();